import { render } from "./ShowNatalChartImages.vue?vue&type=template&id=b56cdf46&scoped=true"
import script from "./ShowNatalChartImages.vue?vue&type=script&lang=js"
export * from "./ShowNatalChartImages.vue?vue&type=script&lang=js"

import "./ShowNatalChartImages.vue?vue&type=style&index=0&id=b56cdf46&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b56cdf46"]])

export default __exports__